/**
 * Log error caught inside saga.
 */
export function logError(message: string, e: Error,
                         level: 'error' | 'warn' | 'info' | 'debug' = 'error') {
  const args: any[] = [];

  let sagaStack: string = (e as any).sagaStack;
  if (sagaStack) {
    if (e.stack)
      sagaStack = sagaStack.replace(e.stack, '');
    args.push(`${sagaStack}\n`);
  }

  args.push(e);
  console[level](`${message}\n`, ...args);
}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/utils/sagas.ts